import React, { FC, Fragment, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { threeShapeStatusVar } from 'apollo/reactive-variables/scan-case';
import { Alert, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import { threeShapeStatusTemplate } from 'apollo/templates/scanner-case';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { ScannerCaseAuthStatus } from 'models/scanner-case';
import { THREE_SHAPE_SCOPE } from 'pages/order-list/scanner-cases/auth-container/three-shape-clinic-auth.component';

const ThreeShapeAuthContainer: FC = () => {
    const { t: translate } = useTranslation(['scan-cases']);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [threeShapeAuthUrl, setThreeShapeAuthUrl] = useState('');
    const threeShapeFrontendStatus = threeShapeStatusVar();
    const { showBoundary } = useDenthubErrorBoundary();
    const isCurrentlyAuthorizing = window.location.href.includes('3shape-auth-callback');

    useQuery(threeShapeStatusTemplate, {
        onCompleted: ({ threeShapeStatus }: { threeShapeStatus: ScannerCaseAuthStatus }) => {
            threeShapeStatusVar(threeShapeStatus);
            if (threeShapeStatus.enabled && !threeShapeStatus.authorized && !isCurrentlyAuthorizing) {
                setDialogOpen(true);
                setThreeShapeAuthUrl(
                    `${CONSTANTS.THREE_SHAPE_AUTH_URL}/connect/authorize?client_id=${threeShapeStatus.clientId}&response_type=code&scope=${THREE_SHAPE_SCOPE}&redirect_uri=${CONSTANTS.THREE_SHAPE_AUTH_REDIRECT}&code_challenge=${threeShapeStatus.codeChallenge}&code_challenge_method=S256&response_mode=query`,
                );
            }
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const onDialogClose = () => {
        setDialogOpen(false);
    };

    return (
        <Fragment>
            {threeShapeFrontendStatus.enabled ? (
                <DHDialog
                    fullWidth
                    maxWidth="sm"
                    open={dialogOpen}
                    onClose={onDialogClose}
                    title={translate('scan-cases:YOU_NEED_TO_LOGIN_TO_THREE_SHAPE')}
                >
                    <Alert severity="info" sx={{ whiteSpace: 'pre-wrap' }}>
                        {translate('scan-cases:THREE_SHAPE_LOGIN_DESC')}
                    </Alert>
                    <Box mt={2} sx={{ textAlign: 'center' }}>
                        <Button variant="contained" href={threeShapeAuthUrl}>
                            {translate('scan-cases:LOGIN_TO_THREE_SHAPE')}
                        </Button>
                    </Box>
                </DHDialog>
            ) : undefined}
        </Fragment>
    );
};

export default ThreeShapeAuthContainer;
